module.exports = __webpack_public_path__ + "img/swiper4.aa371b07.jpg";